module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "voice-call"
  }, [_c('div', {
    staticClass: "info-cont"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("请选择店铺logo：")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.logoImgUrl ? _vm.logoImgUrl : ('https://hxypic.oss-cn-hangzhou.aliyuncs.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png'),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-img"
  }, [_c('i', {
    staticClass: "iconfont icon-xiazai",
    attrs: {
      "title": "上传图片"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "name": "logo",
      "id": ""
    },
    on: {
      "change": _vm.cropImg
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("请填写店铺简介：")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.desc),
      expression: "desc"
    }],
    attrs: {
      "maxlength": "300",
      "name": "desc",
      "id": "",
      "cols": "30",
      "rows": "10",
      "placeholder": "这里填写店铺信息，字数限制在300字内。"
    },
    domProps: {
      "value": (_vm.desc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.desc = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font-count"
  }, [_vm._v(_vm._s(_vm.nowFontCount) + "/300")])]), _vm._v(" "), _c('div', {
    staticClass: "upload"
  }, [_c('button', {
    on: {
      "click": _vm.uploadStoreInfo
    }
  }, [_vm._v("上传")])]), _vm._v(" "), (_vm.showCrop) ? _c('img-crop', {
    attrs: {
      "oldImg": _vm.oldImgBase64,
      "curCropW": _vm.curCropW,
      "curCropH": _vm.curCropH,
      "curStoreId": _vm.curStoreId
    },
    on: {
      "closeImgCrop": function($event) {
        _vm.showCrop = false
      },
      "getCropImgBase": _vm.getCropImgBase
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-686efdf4","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/indexRouters/voiceCall/voiceCall.vue
// module id = 955
// module chunks = 1